import { useMemo } from 'react';
import { useTheme } from '@mui/material';
import {
  attachMenu as defaultAttachMenu,
  chat as defaultChat,
  status as defaultStatus,
} from '../../../theme/tokens/semantic';
import { radius as defaultRadius } from '../../../theme/tokens/radius';
import { shadows as defaultShadows } from '../../../theme/tokens/shadows';
import {
  typography as defaultTypography,
  typographyStyles as defaultTypographyStyles,
} from '../../../theme/tokens/typography';

/**
 * Reads Intervene semantic tokens from the active MUI theme (tenant-aware).
 * Falls back to static tokens when App theme does not extend palette.chat.
 */
export default function useInterveneTheme() {
  const theme = useTheme();

  return useMemo(
    () => ({
      chat: theme.palette?.chat ?? defaultChat,
      status: theme.palette?.status ?? defaultStatus,
      attachMenu: theme.customTokens?.semantic?.attachMenu ?? defaultAttachMenu,
      radius: theme.customTokens?.radius ?? defaultRadius,
      shadows: theme.customTokens?.shadows ?? defaultShadows,
      typography: theme.customTokens?.typography ?? defaultTypography,
      typographyStyles: theme.customTokens?.typographyStyles ?? defaultTypographyStyles,
      spacing: theme.spacing,
      breakpoints: theme.breakpoints,
    }),
    [theme]
  );
}
